// Account-mode API client singletons (api.ato.run, cookie-authenticated).
// All stateless; shared by the route components and the launch controller.
// These are now the app's only API clients: the separate DesktopRuntime
// control plane, which needed a paired endpoint+token and was constructed per
// connection, is retired.
import { RunsApiClient } from "../api/runsClient";
import { RunnersApiClient } from "../api/runnersClient";
import { DiagnosticsApiClient } from "../api/diagnosticsClient";
import { OpenCapsuleClient } from "../api/openCapsuleClient";

// Public Run API client (api.ato.run). Cookie-authenticated: "Get & Run"
// routes through /v1/runs*.
export const runsClient = new RunsApiClient();

// Connected Runner registry client (api.ato.run /v1/runners). Same cookie-
// session boundary as RunsApiClient.
export const runnersClient = new RunnersApiClient();

// Diagnostics read client (api.ato.run /v1/diagnostics). Same cookie-session
// boundary; read-only viewer surface for a finished run's failure reports.
export const diagnosticsClient = new DiagnosticsApiClient();

// Account-authenticated UNIFIED open/stop/cancel client (api.ato.run
// /v1/launches — launch-unification plan §3). Drives the stable
// `/open/:capsule_ref` flow and the console's Stop; cookie session authorizes.
export const openCapsuleClient = new OpenCapsuleClient();
